<script setup>
import { ref, onMounted, computed, watch, defineProps } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import { $api } from '@/services';
import Checkbox from '@/components/elements/checkbox/Checkbox';

const store = useStore();
const formData = ref({});
const skills = ref([]);
const stats = ref({});
const route = useRoute();
const isLoading = ref(true);
const openMenu = ref(false);
const goalDelete = ref([]);
// const modalIsOpen = ref(false);
// const open = ref(false);
const org = computed(() => store.state.profile.current_org);
const props = defineProps(['reload']);

watch(
	() => props.reload,
	() => {
		fetchData();
	}
);

onMounted(() => {
	fetchData();
});

const fetchData = async () => {
	try {
		const res = await $api.form.detail(route.params.id);
		formData.value = res.data.data;
		skills.value = res.data.skills;
		stats.value = res.data.stats;
		isLoading.value = false;
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message:
				err?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
};

const deleting = async (goalId) => {
	try {
		const res = await $api.form.deleteGoalFromForm(route.params.id, goalId);
		if (res.data)
			await store.dispatch('setAlertMessage', {
				message: 'Xoá mục tiêu thành công',
				type: 'success',
			});
		fetchData();
	} catch (err) {
		await store.dispatch('setAlertMessage', {
			message:
				err?.response?.data?.errors?.join('<br/>') ||
				'Đã có lỗi xảy ra. Vui lòng thử lại',
			type: 'danger',
		});
	}
};

function checkAll(data) {
	console.log(data);
	if (data.every((d) => goalDelete.value.includes(d.goal_id))) return true;
	else return false;
}
function addGoalToDelete(data) {
	if (data.every((d) => goalDelete.value.includes(d.goal_id))) {
		data.map((d) => {
			goalDelete.value = goalDelete.value.filter((item) => {
				return item !== d.goal_id;
			});
		});
	} else data.map((d) => goalDelete.value.push(d.goal_id));
}
function addToDelete(id) {
	const result = goalDelete.value.find((item) => item === id);
	if (result) {
		goalDelete.value = goalDelete.value.filter((item) => {
			return item !== id;
		});
	} else {
		goalDelete.value.push(id);
	}
}
function checkStatus(data) {
	if (goalDelete.value.includes(data)) return true;
	else return false;
}
</script>
<template>
	<div class="w-full px-6">
		<div class="py-12 flex items-center justify-between">
			<div>
				<div
					class="
						text-lg
						font-semibold
						text-neutral-400
						whitespace-nowrap
					"
				>
					Xem trước
				</div>
				<div class="text-neutral-500 font-bold text-4xl">
					{{ formData?.name }}
				</div>
			</div>
			<div class="cursor-pointer">
				<svg
					fill="none"
					height="28"
					viewBox="0 0 28 28"
					width="28"
					xmlns="http://www.w3.org/2000/svg"
					@click="$emit('close')"
				>
					<path
						clip-rule="evenodd"
						d="M8.71478 8.71453C9.05649 8.37282 9.61051 8.37282 9.95221 8.71453L14.5835 13.3458L19.2148 8.71453C19.5565 8.37282 20.1105 8.37282 20.4522 8.71453C20.7939 9.05624 20.7939 9.61026 20.4522 9.95197L15.8209 14.5833L20.4522 19.2145C20.7939 19.5562 20.7939 20.1103 20.4522 20.452C20.1105 20.7937 19.5565 20.7937 19.2148 20.452L14.5835 15.8207L9.95221 20.452C9.61051 20.7937 9.05649 20.7937 8.71478 20.452C8.37307 20.1103 8.37307 19.5562 8.71478 19.2145L13.3461 14.5833L8.71478 9.95197C8.37307 9.61026 8.37307 9.05624 8.71478 8.71453Z"
						fill="#94A3B8"
						fill-rule="evenodd"
					/>
				</svg>
			</div>
		</div>
		<div class="p-6 bg-white rounded-2xl">
			<div>
				<div class="flex items-center justify-between mb-4">
					<div class="font-semibold text-neutral-500">
						Thống kê chung
					</div>
					<div
						class="font-semibold text-neutral-500 text-right"
					></div>
				</div>
			</div>
			<div class="grid grid-cols-1 md:grid-cols-2">
				<div
					class="
						p-6
						border
						lg:rounded-l-lg
						md:rounded-tl-lg
						border-neutral-200
						w-full
						md-down:rounded-t md-down:rounded-b-none
					"
				>
					<div
						class="
							text-33
							font-bold
							text-neutral-600
							mb-6
							flex flex-nowrap
							items-center
						"
					>
						<img
							alt=""
							class="mr-2"
							height="32"
							src="@/assets/images/icons/abc.png"
							style="height: 32px"
							width="32"
						/>
						{{ stats?.skill_count }}
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Tổng số lĩnh vực
						</span>
					</div>
				</div>
				<div
					class="
						p-6
						border
						md:border-l-0
						lg:rounded-r-lg
						md:rounded-br-lg
						border-neutral-200
						w-full
						lg-down:border-t-0
						md-down:rounded-b md-down:rounded-t-none
					"
				>
					<div
						class="
							text-33
							font-bold
							text-neutral-600
							mb-6
							flex flex-nowrap
							items-center
						"
					>
						<img
							alt=""
							class="mr-2"
							height="32"
							src="@/assets/images/icons/light.png"
							style="height: 32px"
							width="32"
						/>
						{{ stats?.goal_count }}
					</div>
					<div class="flex flex-nowrap items-center">
						<span class="text-neutral-500 text-sm"
							>Tổng số mục tiêu</span
						>
					</div>
				</div>
			</div>
		</div>
		<!-- <div class="flex justify-end mt-4">
			<button
				class="delete-button flex items-center gap-1"
				:class="{ 'disable-button': goalDelete.length == 0 }"
				@click="openDelete"
			>
				Xoá mục tiêu
			</button>
		</div> -->
		<div>
			<div v-for="(goal, index) in skills" :key="index" class="my-10">
				<div class="font-semibold text-lg text-neutral-600 mb-4">
					{{ index + 1 }}. {{ goal.skill.name }}
				</div>
				<div class="shadow-sm sm:rounded-2xl overflow-hidden">
					<div class="__record__table overflow-x-auto scroll-bar">
						<div class="overflow-hidden sm:rounded-t-2xl">
							<table class="divide-y text-neutral-200">
								<thead class="bg-neutral-100 h-16">
									<tr>
										<!-- <th
											scope="col"
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												w-16
												whitespace-nowrap
											"
										>
											<Checkbox
												:value="checkAll(goal.library_items)"
												@click="
													addGoalToDelete(
														goal.library_items
													)
												"
											></Checkbox>
										</th> -->
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												w-16
												whitespace-nowrap
											"
											scope="col"
										>
											STT
										</th>
										<th
											class="
												px-6
												py-3
												text-left text-xs
												font-semibold
												text-neutral-600
												uppercase
												tracking-wider
												whitespace-nowrap
												w-full
											"
											scope="col"
											style="min-width: 160px"
										>
											Nội dung
										</th>
									</tr>
								</thead>
								<tbody>
									<template
										v-for="(g, i) in goal.library_items"
										:key="g.goal_id"
									>
										<tr
											:class="
												i % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											"
											class="text-neutral-700"
										>
											<!-- <td class="w-16 px-6 py-4">
												<Checkbox
													:value="
														checkStatus(g.goal_id)
													"
													@click="
														addToDelete(g.goal_id)
													"
												></Checkbox>
											</td> -->
											<td
												class="
													px-6
													py-4
													whitespace-nowrap
													text-neutral-700
													flex
												"
											>
												<div class="ml-2">
													{{ i + 1 }}
												</div>
											</td>
											<td
												class="
													px-6
													py-4
													text-neutral-700
												"
											>
												<div class="flex items-center">
													<router-link
														:to="`/goal/${id}/${
															g.goal_id || g.id
														}`"
													>
														<div
															class="
																mr-2
																hover:text-yellow-700
																hover:underline
															"
															v-html="
																g.goal_name ||
																g.name
															"
														></div>
													</router-link>
												</div>
												<div
													v-if="
														(g?.assistance_levels &&
															org.enable_goal_assistance_level) ||
														g?.display_source
													"
													class="flex gap-2 flex-wrap"
													style="max-width: 360px"
												>
													<div
														v-if="g?.display_source"
														class="
															mt-1
															py-0.5
															px-2.5
															rounded-full
															bg-neutral-200
															text-neutral-700
															h-fit
															w-fit
															whitespace-nowrap
															font-semibold
															shadow-input
														"
														style="font-size: 10px"
													>
														{{ g?.display_source }}
													</div>
													<template
														v-if="
															g?.assistance_levels &&
															org.enable_goal_assistance_level
														"
													>
														<div
															v-for="ass in g?.assistance_levels"
															:key="ass"
															class="flex gap-2"
														>
															<div
																class="
																	mt-1
																	py-0.5
																	px-2.5
																	rounded-full
																	bg-pink-100
																	whitespace-nowrap
																	text-neutral-700
																	h-fit
																	w-fit
																	font-semibold
																	shadow-input
																"
																style="
																	font-size: 10px;
																"
															>
																{{ ass }}
															</div>
														</div>
													</template>
												</div>
												<div
													v-if="
														g.parent
															?.sub_goal_count > 0
													"
													class="
														goal-block
														flex
														gap-3
														mt-2
													"
												>
													<img
														class="w-3 h-3 mt-1"
														src="@/assets/images/icons/goal-arrow.png"
														alt=""
													/>
													<div>
														<div
															class="
																text-neutral-700
															"
														>
															{{
																g.parent
																	?.goal_name
															}}
														</div>
														<div
															class="
																text-neutral-400
																text-xs
																font-semibold
															"
														>
															{{
																g.parent
																	?.sub_goal_count
															}}
															MỤC TIÊU
														</div>
													</div>
												</div>
												<div class="mt-6">
													<div
														class="
															flex
															items-center
															justify-end
															md-down:flex-col
															md-down:items-end
															md-down:gap-4
														"
													>
														<div
															class="
																cursor-pointer
																text-yellow-600
																hover:text-yellow-700
																font-semibold
																text-sm
																flex
																items-center
																md-down:items-right
																capitalize
															"
															@click="
																deleting(
																	g.goal_id
																)
															"
														>
															<svg
																class="mr-2"
																fill="none"
																height="16"
																viewBox="0 0 16 16"
																width="16"
																xmlns="http://www.w3.org/2000/svg"
															>
																<path
																	clip-rule="evenodd"
																	d="M2.5 1C1.94772 1 1.5 1.44772 1.5 2V3C1.5 3.55228 1.94772 4 2.5 4H3V13C3 14.1046 3.89543 15 5 15H11C12.1046 15 13 14.1046 13 13V4H13.5C14.0523 4 14.5 3.55228 14.5 3V2C14.5 1.44772 14.0523 1 13.5 1H10C10 0.447715 9.55229 0 9 0H7C6.44772 0 6 0.447715 6 1H2.5ZM5.5 5C5.77614 5 6 5.22386 6 5.5V12.5C6 12.7761 5.77614 13 5.5 13C5.22386 13 5 12.7761 5 12.5L5 5.5C5 5.22386 5.22386 5 5.5 5ZM8 5C8.27614 5 8.5 5.22386 8.5 5.5V12.5C8.5 12.7761 8.27614 13 8 13C7.72386 13 7.5 12.7761 7.5 12.5V5.5C7.5 5.22386 7.72386 5 8 5ZM11 5.5C11 5.22386 10.7761 5 10.5 5C10.2239 5 10 5.22386 10 5.5V12.5C10 12.7761 10.2239 13 10.5 13C10.7761 13 11 12.7761 11 12.5V5.5Z"
																	fill="currentColor"
																	fill-rule="evenodd"
																/>
															</svg>
															XOÁ
														</div>
													</div>
												</div>
											</td>
										</tr>
									</template>
								</tbody>
							</table>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.goal-block {
	background: #eef3f8;
	padding: 12px;
	border-radius: 8px;
	border: 1px solid #bacde4;
}
.delete-button {
	padding: 12px 20px;
	gap: 6px;
	border-radius: 4px;
	border: 1px solid #d89210;
	font-size: 14px;
	font-weight: 600;
	line-height: 20px;
	color: #d89210;
}
.disable-button {
	background: #e1e7ef !important;
	border: 1px solid #cbd5e1 !important;
	color: #cbd5e1;
}
</style>
